/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Architecture_LinkInputs */

const en_marketing_architecture_link = /** @type {(inputs: Marketing_Architecture_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the architecture post`)
};

const es_marketing_architecture_link = /** @type {(inputs: Marketing_Architecture_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer el artículo sobre la arquitectura`)
};

const fr_marketing_architecture_link = /** @type {(inputs: Marketing_Architecture_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire l'article sur l'architecture`)
};

/**
* | output |
* | --- |
* | "Read the architecture post" |
*
* @param {Marketing_Architecture_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_architecture_link = /** @type {((inputs?: Marketing_Architecture_LinkInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Architecture_LinkInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_architecture_link(inputs)
	if (locale === "es") return es_marketing_architecture_link(inputs)
	return fr_marketing_architecture_link(inputs)
});